import { useState, useEffect } from "react";
import get from "lodash.get";
import { useBCGlobalCacheReducer } from "../components/BCGlobaleCacheStore";
import { GlobalConstants } from "../components/constants/GlobalConstants";

export const useLmsCacheSelector = (suffixSelector = "", defaultValue = undefined as any, isGridCounts = false) => {
  const stateSelector = isGridCounts ? `apiCacheGridCounts.${suffixSelector}` : `apiCache.${suffixSelector}`;
  const [state, dispatch] = useBCGlobalCacheReducer();
  const [selectedStoreState, setSelectedStoreState] = useState(get(state, stateSelector, defaultValue) as any);
  const selectedState = suffixSelector ? get(state, stateSelector, defaultValue) : state;

  const updateSelectedStoreState = (data, apiSuffix = suffixSelector) => {
    if (stateSelector) {
      const type = isGridCounts ? GlobalConstants.BCStoreReducerCases.SET_API_CACHE_GRID_COUNT : GlobalConstants.BCStoreReducerCases.SET_API_CACHE;
      const payload = isGridCounts ? { apiSuffix, totalGridCount: data } : { apiSuffix, data };
      dispatch({
        type,
        payload
      });

      setSelectedStoreState(data);
    }
  };

  useEffect(() => {
    if (stateSelector) {
      setSelectedStoreState(get(state, stateSelector, defaultValue));
    }
  }, [selectedState, stateSelector]);

  return [selectedStoreState, updateSelectedStoreState, dispatch];
};